
namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export abstract class OrgaTreeFactory
			{
				public static createNode(
					tree: OrgaTree,
					obj: Wollmilch.ComponentObject,
					root: ui.base.BaseHTMLElement
				): ui.tree.Node|undefined
				{
					switch ( obj.Type )
					{
						case 'Company':
							const company = obj as Wollmilch.CompanyObject;

							const cnode = OrgaTreeFactory.newNode( root, company.Name + " " + company.LegalForm );

							cnode.setIcon( 'building' );

							const config = cnode.appendNewNode( 'Einstellungen' );

							config.setIcon( 'cog' );

							const is24 = OrgaTreeFactory.newNode( config, 'Immoscout24' );

							is24.setIcon( 'building' );

							const addDepartment = cnode.appendNewNode( 'Neue Abteilung anlegen' );

							addDepartment.setIcon( 'plus' );
							addDepartment.css( {
									'font-size': '0.75em',
									'font-style': 'oblique'
								}
							);

							is24.OnClickFN(
								() => tree.setDetails( new IS24ConfigEntry( company, tree ) )
							);

							addDepartment.OnClickFN(
								() => tree.setDetails( new NewDepartmentEntry( company, tree ) )
							);

							cnode.OnClickFN(
								() => tree.setDetails( new CompanyEntry( company, tree ) )
							);
							$('html').one('accountCreated', (e, data) => {
								tree.setDetails( new CompanyEntry( company, tree ) );
							});
							return cnode;

						case 'Employee':
							const emp = obj as Wollmilch.EmployeeObject;

							// const enode = OrgaTreeFactory.newNode( root, '(' + emp.ID + ') ' + emp.Surname + ", " + emp.Name );
							const enode = OrgaTreeFactory.newNode( root, ' ' + emp.Surname + ", " + emp.Name );
							enode.setIcon( 'user' );

							enode.OnClickFN(
								() => tree.setDetails( new EmployeeEntry( emp, tree ) )
							);

							return enode;

						case 'Department':
							const dep = obj as Wollmilch.DepartmentObject;

							// const dnode = OrgaTreeFactory.newNode( root, '(' + obj.ID + ') ' + dep.Name );
							const dnode = OrgaTreeFactory.newNode( root, ' ' + dep.Name );
							dnode.setIcon( 'cube' );

							const addEmployee = dnode.appendNewNode( 'Neuen Mitarbeiter anlegen' );

							addEmployee.setIcon( 'user-plus' );
							addEmployee.css( {
								'font-size': '0.75em',
								'font-style': 'oblique'
								}
							);

							addEmployee.OnClickFN(
								() => tree.setDetails( new NewEmployeeEntry( dep, tree ) )
							);

							// @ts-ignore
							dep.Children.forEach( ( e: Wollmilch.ComponentObject ) => { OrgaTreeFactory.createNode( tree, e, dnode ); } );

							// ! Hier dann eine Factory für Details verwenden!!!!
							dnode.OnClickFN(
								() => tree.setDetails( new DepartmentEntry( dep, tree ) )
							);

							return dnode;
					}

					return undefined;
				}

				private static newNode( root: ui.base.BaseHTMLElement, label: string ): ui.tree.Node
				{
					return root instanceof ui.tree.Node ? root.appendNewNode( label ) : new ui.tree.Node( label, root );
				}
			}
		}
	}
}
